import { ColorRGBA } from 'q-floodfill';

const colorsMatch = (a: ColorRGBA, b: ColorRGBA) => {
  return a.r === b.r && a.g === b.g && a.b === b.b && a.a === b.a;
};

export default colorsMatch;
